import { LabMDM } from "../../masterdata/models/lab";

//this model is used to define the status of the carrier
export class SwabSample{
	/** The barcode. */
	sampleBarCode:string;
    /** The pet name. */
	petName:string;
    /** The pet gender. */
	petGender:string;
    /** The order item id. */
	orderItemId:string;
    /** The activation date. */
	activationDate:string;
	/** The lab. */
	lab:LabMDM;
    /** The plate id. */
	plateID:string;
    /** The position in plate. */
	positionInPlate:string;
    /** The storage id. */
	storageID:string;
	/** The comments. */
	comments:string;
	/** The awb tracking. */
	awbTracking:string;
	/** The received date. */
	receivedDate: string;
	/** The qc check. */
	qcCheck:string;
	/** The index. */
	index:number;
	/** Client ID */
	clientId:string;
}